/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle, Button,
  InputGroup,
} from 'reactstrap';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { Field, Formik } from 'formik';
import Popularity from '../../components/Item/Popularity';
import BaseGrid from '../../components/Common/BaseGrid';
import Statistics from '../../components/Item/Statistics';
import { get, put } from '../../helpers/api_helper';
import { changeSidebarType } from '../../store/actions';

function Offer(props) {
  const history = useHistory();
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [offer, setOffer] = useState(null);
  const [listing, setListing] = useState(null);
  const [items, setItems] = useState({});

  const fetchItem = async (itemId) => {
    try {
      const itm = await get(`/api/items/get/${itemId}`);
      setItems((prevItems) => ({ ...prevItems, [itemId]: itm }));
      return itm;
    } catch (e) {
      return null;
    }
  };

  const fetchListing = async (listingId) => {
    try {
      const lst = await get(`/api/listings/data/${listingId}`);
      lst.items?.forEach(async (itm) => {
        if (!items[itm.id]) {
          await fetchItem(itm.id);
        }
      });
      setListing(lst);
    } catch (e) {
      setListing(null);
    }
  };

  const fetchOffer = async () => {
    try {
      setLoading(true);
      const ent = await get(`/api/offer/${id}`);
      if (ent === '') {
        setOffer(null);
      } else {
        setOffer(ent);
        await fetchListing(ent.listing_id);
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchNext = async () => {
    try {
      setLoading(true);
      const ent = await get(`/api/offer/next-actionable/${id}`);
      if (ent === '') {
        setOffer(null);
      } else {
        fetchOffer();
        history.push(`/offers/${ent.id}`);
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount, currency = 'USD') => (
    amount ? new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).format(amount) : '-'
  );

  const formatPercent = (numerator, denominator) => (
    denominator ? `${((numerator / denominator) * 100).toFixed(2)}%` : '-'
  );

  useEffect(() => {
    fetchOffer();
    if (parseInt(id, 10) === 6) {
      fetchNext();
    }
    // props.changeSidebarType('icon');
  }, [id]);

  const listingAlerts = listing?.items?.filter((item) => (
    item.alert !== null && item.alert !== undefined && item.alert !== ''
  )) || [];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="4">
            <Card>
              <CardBody>
                <CardTitle className="h4">{`${t('Offer')} ${offer !== null ? offer.id : '-'}`}</CardTitle>
                {error !== null && (
                  <p className="text-danger">{error}</p>
                )}
                {error === null && (
                  <div className="table-responsive" style={{ clear: 'both' }}>
                    <table className="table table-bordered table-striped mt-3">
                      <tbody>
                        <tr>
                          <th>{t('ID')}</th>
                          <td>{loading === true || offer === null ? t('...') : offer.id}</td>

                        </tr>
                        <tr>
                          <th>{t('Created At')}</th>
                          <td>
                            <small>{loading !== true && offer !== null && moment(offer.created_at).format('ddd, M/D/YYYY h:mma')}</small>
                            <br />
                            <small>
                              <strong>{loading === true || offer === null ? t('...') : moment(offer.created_at).fromNow()}</strong>
                            </small>
                          </td>
                        </tr>
                        <tr>
                          <th>{t('Offered By')}</th>
                          <td>{loading === true || offer === null ? t('...') : offer.email}</td>
                        </tr>
                        <tr>
                          <th>{t('Asking')}</th>
                          <td>{loading === true || offer === null ? t('...') : formatCurrency(offer.asking)}</td>
                        </tr>
                        <tr>
                          <th>{t('Offer')}</th>
                          <td>{loading === true || offer === null ? t('...') : formatCurrency(offer.offer)}</td>
                        </tr>
                        <tr>
                          <th>{t('Offer %')}</th>
                          <td>{loading === true || offer === null ? t('...') : formatPercent(offer.offer, offer.asking)}</td>
                        </tr>
                        <tr>
                          <th>{t('Counter USD')}</th>
                          <td>{loading === true || offer === null ? t('...') : formatCurrency(offer.counter)}</td>
                        </tr>
                      </tbody>
                    </table>
                    {!!offer?.counter && (
                      <p className="text-info">
                        {t('Countered at')}
                        {' '}
                        {formatCurrency(offer.counter)}
                      </p>
                    )}

                    {!offer?.counter && !!offer?.invoice_id && (
                      <p className="text-info">
                        {t('Accepted at')}
                        {' '}
                        {formatCurrency(offer.offer)}
                      </p>
                    )}
                    {!offer?.counter && !offer?.invoice_id && (
                    // Picker to counter offer amount

                    <Formik
                      enableReinitialize
                      initialValues={{
                        counter: offer ? ((parseFloat(offer.offer) + parseFloat(offer.asking)) / 2.00).toFixed(2) : '',
                      }}
                    >
                      {({ values }) => (
                        <Row>
                          <Col md="6">
                            <InputGroup>
                              <span className="input-group-text">$</span>
                              <Field
                                type="text"
                                className="form-control"
                                id="counter"
                                name="counter"
                              />
                            </InputGroup>
                          </Col>

                          <Col md="3">
                            <Button
                              color="dark"
                              onClick={async () => {
                                if (confirm(t(`Counter this offer at $${values.counter}?`))) {
                                  try {
                                    await put(`/api/offer/counter/${offer.id}`, { counter: values.counter });
                                    toastr.success(t('Offer countered successfully.'));
                                    await fetchNext();
                                  } catch (e) {
                                    toastr.error(t('Error countering offer: ') + e.message);
                                  }
                                }
                              }}
                            >
                              {t('Counter')}
                            </Button>
                          </Col>
                          <Col>
                            <Button
                              color="info"
                              onClick={async () => {
                                if (confirm(t(`Accept this offer at $${offer.offer}?`))) {
                                  try {
                                    await put(`/api/offer/accept/${offer.id}`);
                                    toastr.success(t('Offer accepted successfully.'));
                                    await fetchNext();
                                  } catch (e) {
                                    toastr.error(t('Error accepting offer: ') + e.message);
                                  }
                                }
                              }}
                            >
                              {t('Accept')}
                            </Button>
                          </Col>
                        </Row>
                      )}
                    </Formik>
                    )}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          <Col xl="4">
            <Card>
              <CardBody>
                <CardTitle className="h4">{`${t('Listing Info')}`}</CardTitle>
                {error !== null && (
                  <p className="text-danger">{error}</p>
                )}
                {error === null && (
                  <div className="table-responsive" style={{ clear: 'both' }}>
                    <table className="table table-bordered table-striped mt-3">
                      <tbody>
                        <tr>
                          <th>{t('ID')}</th>
                          <td>
                            {loading === true || offer === null ? t('...') : (
                              <a href={`/listing/${offer.listing_id}`}>
                                {offer.listing_id}
                              </a>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t('SKU')}</th>
                          <td>
                            {loading === true || offer === null ? t('...') : (
                              <a target="_blank" href={`/listing/${offer.listing_id}`} rel="noreferrer">
                                {offer.sku}
                              </a>
                            )}
                          </td>

                        </tr>
                        <tr>
                          <th>{t('Name')}</th>
                          <td>{loading === true || offer === null ? t('...') : offer.title}</td>
                        </tr>
                        <tr>
                          <th>{t('Regular Price')}</th>
                          <td>{loading === true || offer === null ? t('...') : formatCurrency(offer.listing_price)}</td>
                        </tr>
                        <tr>
                          <th>{t('Available Qty')}</th>
                          <td>{loading === true || offer === null ? t('...') : offer.last_qty}</td>
                        </tr>
                        {/*
                        <tr>
                          <th>{t('Searchable')}</th>
                          <td>{'TODO'}</td>
                        </tr>
                        */}
                      </tbody>
                    </table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col xl="4">
            <Card>
              <CardBody>
                <CardTitle className="h4">{`${t('Alerts')}`}</CardTitle>
                {error !== null && (
                  <p className="text-danger">{error}</p>
                )}
                {error === null && loading === false && listingAlerts.length === 0 && (
                  <p className="mt-3 mb-0">{t('No Alerts.')}</p>
                )}
                {error === null && listingAlerts.length > 0 && (
                  <div className="table-responsive" style={{ clear: 'both' }}>
                    <table className="table table-bordered table-striped mt-3">
                      <thead>
                        <tr>
                          <th>{t('P/N')}</th>
                          <th>{t('Alert')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listingAlerts.map((alert) => (
                          <tr key={alert.id}>
                            <td>{alert.part_number}</td>
                            <td>{alert.alert}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        {listing && listing.items && listing.items.map((itm) => (
          <div>
            <Row>
              <Col>
                <Card className="border border-light border-top-0" style={{ borderRadius: '0px' }}>
                  <CardBody>
                    <CardTitle className="h4">{`${t('Recent Sales')}`}</CardTitle>
                    <BaseGrid
                      url="/api/sales"
                      hasSearch
                      filters={`items.listing_id=${listing.id}`}
                      config={
                      {
                        columns: {
                          id: {
                            label: 'ID',
                            sort: true,
                            link: {
                              to: '/sales/%id%',
                            },
                          },
                          created_at: {
                            label: 'Imported',
                            date: {
                              format: (date) => (moment(date).fromNow()),
                              timezone: process.env.LOCAL_TZ,
                            },
                            sort: true,
                          },
                          reference1: {
                            label: 'Ref 1',
                            html: true,
                            sort: true,
                            link: {
                              to: '/sales/%id%',
                            },
                            format: (e, x) => {
                              if (x.canceled_at !== null) {
                                return `<strike class="text-danger">${x.reference1}</strike>`;
                              }

                              return x.reference1;
                            },
                          },
                          reference2: { label: 'Ref 2', sort: true },
                          platform: { label: 'Platform', sort: false },
                          customer_email: { label: 'Email', sort: true },
                          billing_name: { label: 'Billing Name', sort: true, format: (e, x) => (`${x.billing_firstname} ${x.billing_lastname}`) },
                          shipping_name: { label: 'Shipping Name', sort: true, format: (e, x) => (`${x.shipping_firstname} ${x.shipping_lastname}`) },
                          total_paid: {
                            label: 'Total Paid', sort: true, style: { width: '100px' }, format: (e, x) => (`${x.total_paid} ${x.currency_code}`),
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 10,
                        },
                      }
                      }
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <CardTitle className="h4">{`${t('Item')} ${itm.id}`}</CardTitle>
                    <BaseGrid
                      url="/api/items/usages"
                      hasSearch={false}
                      filters={`item_id=${itm.id}`}
                      config={
                      {
                        columns: {
                          thirty_rate: {
                            label: 'ISU',
                            html: true,
                            format: (f) => (
                              `<strong>${f ? f.toFixed(1) : '--'}</strong>`
                            ),
                          },
                          used_qty: { label: 'Used Qty' },
                          in_stock_for: {
                            label: props.t('In-stock for'),
                            format: (f, x) => {
                              // Example dates
                              const start = moment(x.in_at);
                              const end = moment(x.out_at || new Date(Date.now()));

                              // Get the difference in milliseconds
                              const duration = moment.duration(end.diff(start));

                              // Output the largest whole unit (e.g., days)
                              const days = duration.asDays(); // gets days as a float
                              const roundedDays = Math.floor(days);

                              return `${roundedDays} ${roundedDays === 1 ? 'day' : 'days'}`;
                            },
                          },
                          in_at: {
                            label: props.t('In-stock'),
                            date: {
                              format: (date) => (moment(date).format('ddd, MMM D YYYY HH:mm')),
                              timezone: process.env.LOCAL_TZ,
                            },
                          },
                          out_at: {
                            label: props.t('Out of stock'),
                            date: {
                              format: (date) => (moment(date).format('ddd, MMM D YYYY HH:mm')),
                              timezone: process.env.LOCAL_TZ,
                            },
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 30,
                        },
                      }
                      }
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            {items && items[itm.id] && (
              <Row>
                <Col xl="4">
                  <Statistics item={items[itm.id]} />
                </Col>
                <Col xl="4">
                  <Popularity item={items[itm.id]} />
                </Col>
              </Row>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

Offer.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  // changeSidebarType: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({ ...state.Layout });

export default connect(mapStateToProps, {
  changeSidebarType,
})(withTranslation()(Offer));
